var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#43A047"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_6521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.507 4.21054C14.648 4.20946 14.7879 4.23645 14.9184 4.28993C15.049 4.34341 15.1676 4.42233 15.2673 4.52208C15.3671 4.62183 15.446 4.74042 15.4994 4.87095C15.5529 5.00149 15.5799 5.14135 15.5788 5.28242V14.507C15.5799 14.6481 15.5529 14.788 15.4994 14.9185C15.446 15.049 15.3671 15.1676 15.2673 15.2674C15.1676 15.3671 15.049 15.446 14.9184 15.4995C14.7879 15.553 14.648 15.58 14.507 15.5789H5.28235C5.14129 15.58 5.00142 15.553 4.87089 15.4995C4.74036 15.446 4.62176 15.3671 4.52202 15.2674C4.42227 15.1676 4.34335 15.049 4.28987 14.9185C4.23639 14.788 4.2094 14.6481 4.21048 14.507V5.28242C4.2094 5.14135 4.23639 5.00149 4.28987 4.87095C4.34335 4.74042 4.42227 4.62183 4.52202 4.52208C4.62176 4.42233 4.74036 4.34341 4.87089 4.28993C5.00142 4.23645 5.14129 4.20946 5.28235 4.21054H14.507ZM7.05257 12.9114H5.28235V14.507H7.05257V12.9114ZM14.5029 12.9114H8.12038V14.507H14.507L14.5029 12.9114ZM7.05257 10.248H5.28235V11.8476H7.05257V10.248ZM14.5029 10.248H8.12038V11.8476H14.507L14.5029 10.248ZM7.05257 7.58857H5.28235V9.1842H7.05257V7.58857ZM14.5029 7.58857H8.12038V9.1842H14.507L14.5029 7.58857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_6521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.72f47d9b48a86fae934fd4188d7597f2.svg";
export { ForwardRef as ReactComponent };